import React from 'react';
import { Button as ButtonMui } from '@mui/material';
import { ButtonProps as ButtonMuiProps } from '@mui/material/Button';

export const ButtonComponent = ({ children, ...props }: ButtonMuiProps, ref) => {
  return (
    <ButtonMui {...props} ref={ref}>
      {children}
    </ButtonMui>
  );
};

ButtonComponent.displayName = 'ButtonComponent';
export const Button = React.forwardRef(ButtonComponent);
